// filepath: c:\Users\gelis\Documents\GitHub\PisikolojiWeb\frontend\src\features\blog\blogSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import blogService from './blogService';

const initialState = {
  posts: [],
  post: null, // YENİ: Tek bir yazı için state alanı
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
};

// Async Thunks
export const getPosts = createAsyncThunk('blog/getAll', async (_, thunkAPI) => {
  try {
    return await blogService.getPosts();
  } catch (error) {
    const message = (error.response?.data?.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

// YENİ: Slug'a göre tek bir yazı getirmek için async thunk
export const getPostBySlug = createAsyncThunk('blog/getBySlug', async (slug, thunkAPI) => {
    try {
      return await blogService.getPostBySlug(slug);
    } catch (error) {
      const message = (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createPost = createAsyncThunk('blog/create', async (postData, thunkAPI) => {
  try {
    const token = thunkAPI.getState().auth.userInfo.token;
    return await blogService.createPost(postData, token);
  } catch (error) {
    const message = (error.response?.data?.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const updatePost = createAsyncThunk('blog/update', async ({ id, postData }, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.userInfo.token;
      return await blogService.updatePost(id, postData, token);
    } catch (error) {
      const message = (error.response?.data?.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  });

export const deletePost = createAsyncThunk('blog/delete', async (id, thunkAPI) => {
  try {
    const token = thunkAPI.getState().auth.userInfo.token;
    return await blogService.deletePost(id, token);
  } catch (error) {
    const message = (error.response?.data?.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    // reset fonksiyonunu, yeni 'post' state'ini de temizleyecek şekilde güncelle
    reset: (state) => {
        state.posts = [];
        state.post = null;
        state.isError = false;
        state.isSuccess = false;
        state.isLoading = false;
        state.message = '';
    }
  },
  extraReducers: (builder) => {
    builder
      // Get Posts
      .addCase(getPosts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.posts = action.payload;
      })
      .addCase(getPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Create Post
      .addCase(createPost.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createPost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.posts.push(action.payload);
      })
      .addCase(createPost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Update Post
      .addCase(updatePost.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.posts = state.posts.map((post) =>
          post.id === action.payload.id ? action.payload : post
        );
      })
      .addCase(updatePost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // Delete Post
      .addCase(deletePost.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deletePost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.posts = state.posts.filter(
          (post) => post.id !== Number(action.payload.id)
        );
      })
      .addCase(deletePost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      // YENİ: Get Post By Slug için Reducer Case'leri
      .addCase(getPostBySlug.pending, (state) => {
        state.isLoading = true;
        state.post = null; // Yeni bir yazı yüklenirken eskisini temizle
      })
      .addCase(getPostBySlug.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.post = action.payload;
      })
      .addCase(getPostBySlug.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = blogSlice.actions;
export default blogSlice.reducer;